import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { commonRoutes } from "../shared/commonConstants";
import redirectUrl from "../../utils/redirectUrl";

export const RedirectToLogin = () => {

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (location.pathname !== commonRoutes.login) {
            redirectUrl.set(`${location.pathname}${location.search}`);
            navigate(commonRoutes.login, { replace: true });
        }
    }, [location, navigate])

    return (
        <div>Redirecting...</div>
    )
}
